import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { ExcelGenerateModule } from '@ddt-web/excel-generate';
import { HeaderModule } from '@ddt-web/navigation';
import { PasModule } from '@ddt-web/pas';
import { PdfComponentsModule } from '@ddt-web/pdf-components';

import { ExploreCardModule } from './explore-card';
import { ModelsBrowseFilterPipe } from './pipes/models-browse-filter.pipe';
import { RiskProfileIndicatorModule } from './risk-profile-indicator/risk-profile-indicator.module';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		HeaderModule,
		PdfComponentsModule,
		ExcelGenerateModule,
		RiskProfileIndicatorModule,
		ExploreCardModule,
		PasModule
	],
	providers: [ModelsBrowseFilterPipe]
})

export class ModelsBrowsingModule { }
